function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M138.5 193.9l-7.8 23.5 7.1 21.2-6.3 19 13.4 4.5 7.8-23.5-7-21.2 6.3-19-13.5-4.5zm38.9 0l-7.8 23.5 7.1 21.2-6.4 19 13.5 4.5 7.8-23.5-7.1-21.2 6.4-19-13.5-4.5zm-64.3 4.5l-13.4-4.5-7.8 23.5 7.1 21.2-6.4 19 13.5 4.5 7.8-23.5-7.1-21.2 6.3-19zm135.7-42.5l-43.3-70.5V0H78v85.5L34.7 156H21.3v28.3h240.9V156h-13.4v-.1zM106.5 28.5H177v42.3h-70.6l.1-42.3zm-3.6 70.8h77.7l34.8 56.6H68.1l34.8-56.6z"
})));